export default {
  breadcrumb: {
    wrapper: 'block md:whitespace-nowrap lg:whitespace-nowrap breadcrumb mx-auto px-8 lg:px-0',
    item: '',
    link: 'text-black no-underline',
    separator: 'mx-2 text-12 px-5',
  },
};
